import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { styles } from './utils/config';

export const highlightsStateAtom = atomWithStorage('highlightsSettings', {
  force: null,
  basicCommandUnit: null,
  sector: null,
  team: null,
});

export const mapStyleAtom = atomWithStorage('mapStyle', styles[0].path);

export const vehiclesStateAtom = atom({
  searchText: '',
  sortBy: 'registrationNumber',
  sortDesc: false,
  filter: {
    imei: '',
    vin: '',
    disposed: false,
    stale: '',
    ancestor: null,
  },
  showSettings: false,
});

export const peopleStateAtom = atom({
  searchText: '',
  sortBy: 'surname',
  sortDesc: false,
  filter: {
    rfid: '',
    radio: '',
    leaver: false,
    ancestor: null,
  },
  showSettings: false,
});

export const locationsStateAtom = atom({
  searchText: '',
  sortBy: 'name',
  sortDesc: false,
  filter: {
    ancestor: null,
  },
  showSettings: false,
});

export const objectivesStateAtom = atom({
  searchText: '',
  sortBy: 'title',
  sortDesc: false,
  filter: {
    createdBy: '',
    ward: '',
    occurrenceNumber: '',
    status: '',
    boundaryType: '',
    attributes: {},
  },
  showSettings: false,
  showCopyButtons: false,
});

export const groupsStateAtom = atom({
  searchText: '',
  sortBy: 'name',
  sortDesc: false,
  filter: {
    ancestor: null,
    type: '',
    parentCount: '',
    missingAliasType: '',
  },
  showSettings: false,
  showCopyButtons: false,
});

const storage = createJSONStorage(() => sessionStorage);
export const alertsAtom = atomWithStorage('alerts', [], storage);

export const acceptedAtom = atomWithStorage('accepted', false);

export const sideNavOpenAtom = atom(false);

export const mapActionsAtom = atom({
  scrollTo: () => {},
  panTo: () => {},
});
